import {
  type MutationFunction,
  type QueryClient,
  useMutation,
} from '@tanstack/react-query';

import { type AuditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { AUDIT_FORMS_QUERY_KEY } from '#apps/client-web/features/audit-form/types/react-query';

import { type AuditId } from '#packages/data-collection/models/audit';
import {
  type AuditForm,
  type AuditFormType,
} from '#packages/data-collection/models/audit-form';

export const useSaveAuditFormMutation = <T extends AuditForm>({
  auditFormService,
  queryClient,
  auditId,
  formType,
}: {
  auditFormService: AuditFormService;
  queryClient: QueryClient;
  auditId: AuditId;
  formType: AuditFormType;
}) =>
  useMutation(
    {
      mutationKey: [AUDIT_FORMS_QUERY_KEY, auditId, formType],
      mutationFn: auditFormService.save.bind(
        auditFormService,
      ) as unknown as MutationFunction<T>,
    },
    queryClient,
  );
